import { LogoType } from '@wix/shoutout-email-model-v3';
export const WIX_BRAND_LOGO_URLS = {
  [LogoType.wixClassic]: '82f27b_51c1e39598f94531ab9d830494fe17df~mv2.png',
  [LogoType.wixStudio]: '82f27b_af1457d5816a4550a50283a8c5601232~mv2.png',
  [LogoType.wixPayments]: 'b02258_e40cf8b05f1c4538b396236067ea03fc~mv2.png',
  [LogoType.wixVibe]: 'b02258_e1bf6daf6c3e4047a3cf9c28ff8c168c~mv2.png',
  [LogoType.marketplace]: 'd2f3f5_42e3a2b34fbf414c88efc9470fccc78f~mv2.png',
  [LogoType.rise]: 'b02258_02ccd3d0275e4a6ea6557b4a6d4c1387~mv2.png',
  [LogoType.wixel]: 'b02258_1432327f45b94120bf5d216c5031fef5~mv2.png',
  [LogoType.quickbooksAndClassic]: 'b02258_824645923f40486287f4384f0ceb4002~mv2.png',
  [LogoType.quickbooksAndStudio]: 'b02258_845ea4ff182b48959cb5ca02951f6a9c~mv2.png',
  [LogoType.hopp]: '2ee022_34c1df8343d54476af81ca44321f5d1e~mv2.png'
};
export const WIX_BRAND_LOGO_TYPES = [LogoType.wixClassic, LogoType.wixStudio, LogoType.wixPayments, LogoType.wixVibe, LogoType.marketplace, LogoType.rise, LogoType.wixel, LogoType.quickbooksAndClassic, LogoType.quickbooksAndStudio, LogoType.hopp];
export const WIX_BRAND_LOGO_MAP = [{
  id: LogoType.wixClassic,
  value: 'Wix Classic'
}, {
  id: LogoType.wixStudio,
  value: 'Wix Studio'
}, {
  id: LogoType.wixPayments,
  value: 'Wix Payments'
}, {
  id: LogoType.wixVibe,
  value: 'Wix Vibe'
}, {
  id: LogoType.marketplace,
  value: 'Wix Marketplace'
}, {
  id: LogoType.rise,
  value: 'Rise AI'
}, {
  id: LogoType.wixel,
  value: 'Wixel'
}, {
  id: LogoType.quickbooksAndClassic,
  value: 'Wix.com & Quickbooks'
}, {
  id: LogoType.quickbooksAndStudio,
  value: 'Wix Studio & Quickbooks'
}, {
  id: LogoType.hopp,
  value: 'Hopp'
}];
export const WIX_BRAND_LOGO_STYLE_OVERRIDES = {
  [LogoType.wixel]: {
    // interface ILogoRegionStyles from shoutout-email-model-v3
    // didn't install to avoid circular dependency
    fixedImageHeight: 36
  },
  [LogoType.quickbooksAndClassic]: {
    fixedImageHeight: 44
  },
  [LogoType.quickbooksAndStudio]: {
    fixedImageHeight: 44
  }
};
//# sourceMappingURL=consts.js.map